/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
// Internal Imports
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Staff from '@linc-technologies/linced-common/enums/roles/staff';

export default class ExpulsionsRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  // State
  // dateFrom provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateFrom = moment().format('YYYY-MM-DD');

  // dateTo provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateTo = moment().format('YYYY-MM-DD');

  setupController(controller) {
    super.setupController(...arguments);
    controller.onActivate();
  }

  isPrincipal(person) {
    if (isEmpty(person.roles)) {
      return false;
    }
    return person.roles.includes(Staff.PRINCIPAL);
  }

  model(params) {
    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;

    return hash({
      expulsions: this.store.query('attendance/expulsion', {
        schoolId: this.get('session.activeSchool'),
        dateFrom,
        dateTo,
      }),
      homerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: this.year,
      }),
      suspensionPostPage: this.store
        .query('posts/page', {
          isSuspensionPosts: true,
        })
        .then((pages) => {
          return pages[0];
        }),
      suspensionLettersPage: this.store
        .query('posts/page', {
          isSuspensionLetters: true,
        })
        .then((pages) => {
          return pages[0];
        }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
      principal: this.store
        .query('person', { type: PersonType.STAFF })
        .then((staff) => {
          return staff.find((person) => this.isPrincipal(person));
        }),
      suspensions: null,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    if (!isEmpty(model.expulsions)) {
      let expulsionIds = model.expulsions.map((expulsion) => {
        return expulsion.get('id');
      });
      return this.store
        .query('attendance/suspension', {
          schoolId: this.get('session.activeSchool'),
          expulsionIds: JSON.stringify(expulsionIds),
        })
        .then((res) => {
          return (model.suspensions = res);
        });
    }
  }
}
